
export const NoPendingCards = () => {
  return (
    <svg width="74" height="54" viewBox="0 0 74 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.547852" width="73" height="52" rx="3.5" fill="white" stroke="#DDDDDD" />
      <rect x="8" y="9.04785" width="57" height="8" rx="4" fill="#D6D6D6" />
    </svg>
  );
};
